var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',[_vm._v(" Once you click finish, your business will be created and you will be automatically redirected to the business page ")])}
var staticRenderFns = []

export { render, staticRenderFns }